import { InfoRegular, ShieldTaskRegular, PersonKeyRegular, LaptopRegular, ChatMultipleRegular } from '@fluentui/react-icons'
import { PanelShell } from './PanelShell'
import styles from './AboutPanel.module.css'
import grid from './PanelGrid.module.css'

interface PanelProps {
  onOpenWorkspace: () => void
}

const branches = [
  {
    id: 'incident',
    icon: ShieldTaskRegular,
    title: 'Incident Agent',
    source: 'Sentinel / Defender XDR',
    detail: 'Alerts & entities',
  },
  {
    id: 'identity',
    icon: PersonKeyRegular,
    title: 'Identity Agent',
    source: 'Microsoft Entra ID',
    detail: 'Sign-ins & risk',
  },
  {
    id: 'endpoint',
    icon: LaptopRegular,
    title: 'Endpoint Agent',
    source: 'Microsoft Defender',
    detail: 'Device telemetry',
  },
]

export function AboutPanel({ onOpenWorkspace }: PanelProps) {
  return (
    <PanelShell
      icon={InfoRegular}
      title="About"
      subtitle="Architecture and current project phase for SOC-Copilot."
      onOpenWorkspace={onOpenWorkspace}
    >
      <div className={grid.phaseBanner}>
        <p className={grid.phaseText}>
          <strong>Current phase: Investigate &amp; Advise.</strong> No automated remediation is
          performed.
        </p>
      </div>

      <div className={styles.diagram}>
        <div className={styles.hub}>
          <ChatMultipleRegular className={styles.hubIcon} aria-hidden="true" />
          <span>SOC-Copilot</span>
        </div>
        <div className={styles.trunk} aria-hidden="true" />
        <div className={styles.branchRow}>
          <div className={styles.branchConnector} aria-hidden="true" />
          {branches.map((branch) => {
            const Icon = branch.icon
            return (
              <div key={branch.id} className={styles.branch}>
                <div className={styles.stem} aria-hidden="true" />
                <div className={styles.branchCard}>
                  <Icon className={styles.branchIcon} aria-hidden="true" />
                  <span className={styles.branchTitle}>{branch.title}</span>
                  <span className={styles.branchSource}>{branch.source}</span>
                  <span className={styles.branchDetail}>{branch.detail}</span>
                </div>
              </div>
            )
          })}
        </div>
      </div>

      <div className={grid.proseCard}>
        <h3>Read-only investigation, by design</h3>
        <p>
          SOC-Copilot investigates Microsoft Sentinel / Defender XDR incidents, identities and
          endpoints, correlates evidence across those domains, and explains security risk. It does
          not currently execute containment or remediation actions — response decisions remain
          with your security team.
        </p>
      </div>

      <p className={styles.footnote}>Microsoft-powered security investigation</p>
    </PanelShell>
  )
}
